// src/components/BookingCard.jsx
import React from 'react';
import Swipeable from './Swipeable';
import {CalendarDays, CheckCircle2} from 'lucide-react';
import {format} from 'date-fns';
import ru from 'date-fns/locale/ru';

export default function BookingCard({b, type, onCheckout}) {
    const isCheckout = type === 'today' || type === 'tomorrow';

    return (
        <Swipeable
            onSwipedLeft={() => isCheckout && onCheckout?.(b.id, b.name)}
            trackMouse={true}
            delta={50}
        >
            <div
                className="relative bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden cursor-grab active:cursor-grabbing select-none">
                {/* Красный фон при свайпе (только визуально) */}
                <div
                    className="absolute inset-0 bg-gradient-to-l from-red-500 to-red-600 flex items-center justify-end pr-8 opacity-0 transition-opacity pointer-events-none">
                    <CheckCircle2 className="w-16 h-16 text-white"/>
                </div>

                <div className="relative p-6">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-4">
                            <div
                                className="w-14 h-14 bg-gray-900 text-white rounded-full flex items-center justify-center text-xl font-bold shrink-0">
                                {b.room}
                            </div>

                            <div>
                                <h3 className="text-xl font-bold text-gray-900">{b.name || 'Гость'}</h3>
                                <p className="text-sm text-gray-600">Номер {b.room}</p>
                            </div>
                        </div>

                        {isCheckout && (
                            <div className="text-right">
                                <p className="text-xs text-red-600 font-medium animate-pulse">свайп ←</p>
                                <CheckCircle2 className="w-10 h-10 text-red-600 mt-1"/>
                            </div>
                        )}
                    </div>

                    <div className="flex items-center gap-3 text-sm">
                        <CalendarDays size={18} className="text-gray-500"/>
                        <span className={isCheckout ? 'text-red-600 font-medium' : 'text-blue-600'}>
              {isCheckout ? 'Выезд' : 'Заезд'}{' '}
                            {(() => {
                                const date = isCheckout ? b.checkOut : b.checkIn;
                                return date ? format(new Date(date), 'd MMMM', {locale: ru}) : '—';
                            })()}
            </span>
                    </div>

                    {isCheckout && (
                        <p className="text-right text-xs text-red-500 mt-4 opacity-70">
                            ← свайп для отметки выезда
                        </p>
                    )}
                </div>
            </div>
        </Swipeable>
    );
}
